import { render, staticRenderFns } from "./AmountDiffReasonScreen.vue?vue&type=template&id=2e75163d&"
import script from "./AmountDiffReasonScreen.vue?vue&type=script&lang=js&"
export * from "./AmountDiffReasonScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports